export const pendingActions = (state) => state.relogin.pendingActions;
